/* globals $ userRolesAuth */
/* eslint-disable */
import moment from 'moment'
import angular from 'angular'
import _ from 'lodash'
import intl from 'react-intl-universal'
import ReactDOM from 'react-dom'
import React from 'react'
import { Provider } from 'react-redux'

import dataWranglingUtils from '../dataWrangling/utils.js'
import exceptionTypes from '../errors/exception.types.js'
import { StateRequest } from './publishActions.dataTypes'
import { hasPermission } from '../services/permission'
import { publishUnpublishedImages } from '../services/story/imagePublishing'
import CONSTANTS from '~/constants'
import { FeaturesProvider } from '~/reactapp/App/FeaturesContext'
import { setStoryAns } from '../../redux/storyData.js'

export default [
  '$rootScope',
  '$element',
  '$timeout',
  'toastr',
  'publishService',
  'metaTemplatesService',
  'settingsService',
  'storyService',
  'timePickerService',
  '$filter',
  'planningService',
  'authorizationService',
  'errorDelegationService',
  'validationService',
  'beatsService',
  '$scope',
  'locklessService',
  'dataUILinkerService',
  '$location',
  '$ngRedux',
  'pharosService',
  'getErrorMessage',
  publishActionsController,
]

const DATEFORMAT = 'll - LT'
const EXISTING_LABEL = intl.get('publishActions.publishModal.boltCurrent')
const BOLT_NOW = intl.get('publishActions.publishModal.boltNow')
const BOLT_NOW_ID = BOLT_NOW.toLowerCase()
const BUTTON_SCHEDULE = intl.get('publishActions.publishModal.buttonSchedule')
const BUTTON_UPDATE = intl.get('publishActions.publishModal.buttonUpdate')
const BUTTON_PUBLISH = intl.get('publishActions.publishModal.buttonPublish')
const captureBaseline = function captureBaseline(vector = 'forward') {
  const offset = 1
  const unit = 'minutes'
  if (vector === 'forward') {
    return moment().add(offset, unit).toDate()
  } else if (vector === 'backward') {
    return moment().subtract(offset, unit).toDate()
  }
  throw new exceptionTypes.InvalidAttribute(
    `vector[${vector}] passed is not supported`
  )
}

const existingDisplayDateFromStoryObject = function existingDisplayDateFromStoryObject(
  storyObj
) {
  return dataWranglingUtils.selectFirst(
    dataWranglingUtils.extractProperties(storyObj, ['display_date']),
    [
      [
        dataWranglingUtils.isStringType,
        dataWranglingUtils.ansStringToDateObject,
      ],
      [
        dataWranglingUtils.isMomentType,
        function momentToDate(time) {
          return time.toDate()
        },
      ],
      [
        dataWranglingUtils.isDateType,
        function dateToDate(time) {
          return time
        },
      ],
    ],
    null
  )
}

function publishActionsController(
  $rootScope,
  $element,
  $timeout,
  toastr,
  publishService,
  metaTemplatesService,
  settingsService,
  storyService,
  timePickerService,
  $filter,
  planningService,
  authorizationService,
  errorDelegationService,
  validationService,
  beatsService,
  $scope,
  locklessService,
  dataUILinkerService,
  $location,
  $ngRedux,
  pharosService,
  getErrorMessage
) {
  // Utility Functions
  const renderExistingDisplayDateLabel = function renderExistingDisplayDateLabel(
    existingDisplayDate
  ) {
    return `${$filter('dateDisp')(
      existingDisplayDate,
      DATEFORMAT
    )} (${EXISTING_LABEL})`
  }

  const buildInitialDisplayDateBolts = function buildInitialDisplayDateBolts(
    storyObj
  ) {
    const newDateTimes = [{ label: BOLT_NOW, datum: new Date() }]
    let existingDisplayDate = existingDisplayDateFromStoryObject(storyObj)
    if (
      angular.isDefined(existingDisplayDate) &&
      existingDisplayDate !== null
    ) {
      newDateTimes.push({
        label: renderExistingDisplayDateLabel(existingDisplayDate),
        datum: existingDisplayDate,
      })
    }
    return newDateTimes
  }
  // End Utility Functions
  // used by commitPublication

  const toBeDestroyed = []

  $scope.$on('$destroy', function destroyerOfScopes() {
    toBeDestroyed.reduce(function destroyerOfScopesReducer(acc, func) {
      func()
      return acc
    }, [])
  })

  this.publish_state = {}
  this.scheduled_state = {}
  this.expiration_state = {
    scheduled_expiration_date: null,
  }

  const self = this
  this.holdDates = false
  this.holders = {}
  this.unpublishedImagesErrorMsg = ''
  this.unpublishedImagesSuccessMsg = ''
  this.intl = intl
  this.isNotScheduled = () => {
    return self.unPublish.datum.label === BOLT_NOW
  }
  $scope.CONSTANTS = CONSTANTS

  const renderActions = () => {
    import(/* webpackChunkName: 'Publish' */ '~/reactapp/App/Publish').then(
      ({ PublishActions }) => {
        ReactDOM.render(
          <Provider store={$ngRedux}>
            <FeaturesProvider features={$rootScope.features}>
              <PublishActions />
            </FeaturesProvider>
          </Provider>,
          $element.find('#publishActions-react')[0]
        )
      }
    )
  }

  this.$onChanges = () => {
    if (this.storyObj) {
      renderActions()
    }
  }

  // The following objects in onInit are being used to initialize state within dataUILinkerService.procComponentState(this)
  // dataUILinkerService.procComponentState(this) is a custom state manager by a pervious developer.
  // handlers: are functions that will be called depending on the object's mutator's array
  // datum: an object used as data storage. mutators/handlers update the datums. datums are bound in the templates and are treated like props in react.
  // mutators: an array that defines what handlers to call in order. the array can be function names or annon functions. they are treated like event handlers
  this.$onInit = () => {
    /* Normally, the ngScope takes care of the state of the component. However, using the API is not really an option.
     *  In this rewrite, I will focus on using an object to manage state of a UIComponent.
     */
    this.story = this.storyObj
    let defaultPublishDate = this.storyObj.publish_date
      ? new Date(this.storyObj.publish_date)
      : null
    if (defaultPublishDate && defaultPublishDate.getTime() < Date.now()) {
      defaultPublishDate = null
    }
    this.lockui = {
      datum: false,
    }
    this.canSchedulePublication = {
      handlers: {},
      datum: true,
      mutators: [
        function (state, defer) {
          authorizationService
            .canSchedulePublication()
            .then(function canSchedulePublicationSuccess() {
              state['datum'] = true
            })
            .catch(() => {
              state.datum = false
            })
        },
      ],
    }
    this.canPublish = {
      handlers: {},
      datum: true,
      mutators: [
        function (state, defer) {
          authorizationService
            .canPublish(self.storyObj)
            .then(function canPublishSuccess() {
              state['datum'] = true
            })
            .catch(() => {
              state.datum = false
            })
        },
      ],
    }
    this.unPublish = {
      handlers: {
        setDefault: (state) => {
          const scheduledDate = _.get(
            self,
            'scheduled_state.scheduled_publish_date',
            false
          )
          const isPublished = _.get(
            self,
            'publishState.datum.isPublished',
            false
          )

          if (isPublished) {
            state.datum = state.boltTimes[0]
          } else if (scheduledDate) {
            const date = new Date(scheduledDate)
            const label = $filter('dateDisp')(scheduledDate, DATEFORMAT)
            state.datum = { label: label, date: date }
          }
        },
        unpublish: (state, defer) => {
          const {
            datum: { date },
          } = state

          // Don't let user schedule now
          if (
            new Date(self.scheduled_state.scheduled_publish_date).getTime() ===
            date.getTime()
          ) {
            toastr.error(intl.get('publishActions.unpublishModal.error'))
            return
          }
          // Check if we are unpublishing NOW or scheduling
          if (this.isNotScheduled()) {
            // Update Now time prior to unpublish
            state.datum.date = new Date()
            // Content Ops doesn't automatically remove any schedued unpublish dates when an article is unpublished
            if (self.expiration_state.scheduled_expiration_date) {
              this.unscheduleExpirationDate()
            }
            publishService
              .unpublish({ _id: self.storyObj._id })
              .then(function unpublishSuccess() {
                self.publishState['handlers']['reset']() // call it manually to avoid a circular dependency.
                self.saveStoryProgress.handlers.meepMeep()
                toastr.success(
                  intl.get('publishActions.toast.unpublishSuccess')
                )
                if (!self.publishTimeLinked) {
                  self.toggleLinkPublishTime()
                }
                defer.notify()
              })
              .catch(function unpublishError(err) {
                pharosService.sendErrorMessageToSentry(err)
              })
          } else {
            publishService
              .scheduleUnpublish({
                _id: self.storyObj._id,
                scheduleDateTime: date,
              })
              .then((res) => {
                self.expiration_state.scheduled_expiration_date = date
                self.saveStoryProgress.handlers.meepMeep()
                toastr.success(
                  intl.get('publishActions.toast.unpublishSuccess')
                )
              })
              .catch((err) => {
                pharosService.sendErrorMessageToSentry(err)
              })
          }
        },
        timeUpdate: (state, defer, jqEvent, time) => {
          const isPublished = _.get(
            self,
            'publishState.datum.isPublished',
            false
          )
          const resetValue = isPublished ? state.boltTimes[0] : state.blank
          const publishedOrScheduledDate = this.getScheduledOrPublishTime()
          let date = new Date(time)
          // Selected unpublish time must be greater than greatest publish/scheduled time
          if (date.getTime() < publishedOrScheduledDate) {
            state.datum = resetValue
            toastr.error(intl.get('publishActions.unpublishModal.error'))
          } else {
            const label = $filter('dateDisp')(date, DATEFORMAT)
            state.datum = { label: label, date: date }
          }
        },
        onBoltSelect: (state, defer, jqEvent, bolt) => {
          // set value on bolt select
          state.datum = bolt
        },
      },
      datum: { label: BOLT_NOW, date: new Date() },
      boltTimes: [{ label: BOLT_NOW, date: new Date() }],
      blank: { label: '', date: '' },
      mutators: [],
    }
    this.canUnschedule = {
      handlers: {
        knock: function knock(state, defer) {
          if (!_.get(self, 'storyObj._id')) {
            return
          }
          locklessService
            .loadUserRolesAuth()
            .then(function handleUserRolesAuthCanUnpublish(userRolesAuth) {
              locklessService
                .loadPublishState()
                .then(function handlePublishStateCanUnpublish(publishState) {
                  planningService
                    .loadScheduledPublications(self.storyObj._id)
                    .then(function loadScheduledPublications(publications) {
                      let scheduled = publications.filter(
                        (i) => i.job_type === 'publish'
                      )
                      state['datum'] =
                        userRolesAuth.story &&
                        hasPermission(userRolesAuth.story.unpublish) &&
                        scheduled.length > 0
                      defer.resolve(state['datum'])
                    })
                })
            })
        },
      },
      datum: true,
      mutators: [
        'publishState',
        function (state, defer, publishState) {
          if (!_.get(self, 'storyObj._id')) {
            return
          }
          publishState.then(null, null, function canPublishHandlepublishState(
            publishState
          ) {
            locklessService
              .loadUserRolesAuth()
              .then(function handleUserRolesAuthCanUnpublish(userRolesAuth) {
                planningService
                  .loadScheduledPublications(self.storyObj._id)
                  .then(function loadScheduledPublications(publications) {
                    let scheduled = publications.filter(
                      (i) => i.job_type === 'publish'
                    )
                    state['datum'] =
                      userRolesAuth.story &&
                      hasPermission(userRolesAuth.story.unpublish) &&
                      scheduled.length > 0
                    defer.resolve(state['datum'])
                  })
              })
          })
          locklessService
            .loadUserRolesAuth()
            .then(function handleUserRolesAuthCanUnpublish(userRolesAuth) {
              locklessService
                .loadPublishState()
                .then(function handlePublishStateCanUnpublish(publishState) {
                  planningService
                    .loadScheduledPublications(self.storyObj._id)
                    .then(function loadScheduledPublications(publications) {
                      let scheduled = publications.filter(
                        (i) => i.job_type === 'publish'
                      )
                      state['datum'] =
                        userRolesAuth.story &&
                        hasPermission(userRolesAuth.story.unpublish) &&
                        scheduled.length > 0
                      defer.resolve(state['datum'])
                    })
                })
            })
        },
      ],
    }
    this.canUnpublish = {
      handlers: {},
      datum: false,
      mutators: [
        'publishState',
        function (state, defer, publishState) {
          publishState.then(null, null, function canPublishHandlepublishState(
            publishState
          ) {
            locklessService
              .loadUserRolesAuth()
              .then(function handleUserRolesAuthCanUnpublish(userRolesAuth) {
                state['datum'] =
                  userRolesAuth.story &&
                  hasPermission(userRolesAuth.story.unpublish) &&
                  publishState.isPublished
                defer.resolve(state['datum'])
              })
          })
          locklessService
            .loadUserRolesAuth()
            .then(function handleUserRolesAuthCanUnpublish(userRolesAuth) {
              locklessService
                .loadPublishState()
                .then(function handlePublishStateCanUnpublish(publishState) {
                  state['datum'] =
                    userRolesAuth.story &&
                    hasPermission(userRolesAuth.story.unpublish) &&
                    publishState.isPublished
                  defer.resolve(state['datum'])
                })
            })
        },
      ],
    }
    this.publishField = {
      handlers: {
        publishFieldUpdate: function publishFieldUpdate(
          state,
          defer,
          jqEvent,
          time
        ) {
          // don't set a date after scheduled unpublish date
          const scheduledExpirationDate = _.get(
            self,
            'expiration_state.scheduled_expiration_date',
            false
          )
          if (scheduledExpirationDate) {
            if (
              time.getTime() > new Date(scheduledExpirationDate).getTime() ||
              time.getTime() < new Date().getTime()
            ) {
              toastr.error(intl.get('publishActions.publishField.errorGreater'))
            } else {
              state['datum'] = time
            }
          } else {
            if (time.getTime() < new Date().getTime()) {
              state['datum'] = new Date()
              toastr.error(intl.get('publishActions.publishField.error'))
            } else {
              state['datum'] = time
            }
          }

          if (self.publishTimeLinked) {
            self.displayField['handlers']['update'](
              jqEvent,
              state['datum'],
              true
            )
          }
          defer.notify(state['datum'])
        },
      },
      datum: defaultPublishDate || new Date(),
      mutators: [
        'publishFieldBolts',
        'saveStory',
        function (state, defer, publishFieldBolts, saveStory) {
          publishFieldBolts.then(null, null, function handlePublishFieldBolts(
            publishFieldBolts
          ) {
            state['datum'] = publishFieldBolts['datum']
          })
          saveStory.then(null, null, (storyObj) => {
            const existingPublishDate = storyObj.publish_date
              ? new Date(storyObj.publish_date)
              : null
            if (
              !existingPublishDate ||
              existingPublishDate.getTime() < Date.now()
            ) {
              state['datum'] = new Date()
            } else {
              state['datum'] = existingPublishDate
            }
            defer.notify(state['datum'])
          })
        },
      ],
    }

    this.publishFieldLabel = {
      handlers: {},
      datum: {
        date: defaultPublishDate,
        label: defaultPublishDate
          ? $filter('dateDisp')(defaultPublishDate, DATEFORMAT)
          : BOLT_NOW,
      },
      mutators: [
        'publishField',
        'publishFieldBolts',
        function (state, defer, publishField, publishFieldBolts) {
          publishFieldBolts.then(null, null, function handlePublishFieldBolts(
            bolt
          ) {
            state['datum']['label'] = bolt['label']
            state['datum']['date'] = bolt['datum']
          })
          publishField.then(null, null, function handlePublishField(
            publishField
          ) {
            if (
              publishField > captureBaseline('backward') &&
              publishField < captureBaseline()
            ) {
              state['datum']['label'] = BOLT_NOW
              state['datum']['date'] = null
            } else {
              state['datum']['label'] = $filter('dateDisp')(
                publishField,
                DATEFORMAT
              )
              state['datum']['date'] = publishField
            }
          })
        },
      ],
    }
    this.publishModalCommitCtrl = {
      handlers: {},
      datum: BUTTON_PUBLISH, // Default,
      unpublishedStoryPublishingNow: true,
      mutators: [
        'publishField',
        'publishFieldBolts',
        'publishState',
        'saveStory',
        function (
          state,
          defer,
          publishField,
          publishFieldBolts,
          publishState,
          saveStory
        ) {
          const setUnpublishedStoryPublishingNow = (state) => {
            state.unpublishedStoryPublishingNow =
              state['datum'] === BUTTON_PUBLISH
          }

          publishFieldBolts.then(null, null, function handlePublishFieldBolts(
            bolt
          ) {
            locklessService
              .loadPublishState()
              .then(function loadPublishStateSuccess(publishState) {
                if (bolt['label'].toLowerCase() !== BOLT_NOW_ID) {
                  state['datum'] = BUTTON_SCHEDULE
                } else if (
                  publishState.isPublished &&
                  bolt['label'].toLowerCase() === BOLT_NOW_ID
                ) {
                  state['datum'] = BUTTON_UPDATE
                } else {
                  state['datum'] = BUTTON_PUBLISH
                }

                setUnpublishedStoryPublishingNow(state)
              })
          })

          publishField.then(null, null, function handlePublishField(
            publishField
          ) {
            locklessService
              .loadPublishState()
              .then(function loadPublishStateSuccess(publishState) {
                if (publishField > captureBaseline()) {
                  state['datum'] = BUTTON_SCHEDULE
                } else if (publishState.isPublished) {
                  state['datum'] = BUTTON_UPDATE
                } else {
                  state['datum'] = BUTTON_PUBLISH
                }

                setUnpublishedStoryPublishingNow(state)
              })
          })

          publishState.then(null, null, function publishStateHandler(
            publishState
          ) {
            if (publishState.isPublished) {
              state['datum'] = BUTTON_UPDATE
            } else {
              state['datum'] = BUTTON_PUBLISH
            }
          })

          saveStory.then(null, null, (storyObj) => {
            locklessService.loadPublishState().then((publishState) => {
              if (publishState.isPublished) {
                state['datum'] = BUTTON_UPDATE
              } else if (self.scheduled_state.isScheduledPublish) {
                state['datum'] = BUTTON_SCHEDULE
              } else {
                state['datum'] = BUTTON_PUBLISH
              }

              setUnpublishedStoryPublishingNow(state)
            })
          })
        },
      ],
    }
    this.scheduledState = {
      handlers: {
        knock: function knock(state, defer, publishDate) {
          self.scheduled_state.isScheduledPublish = true
          self.scheduled_state.scheduled_publish_date = publishDate
        },
        reset: function reset(state, defer) {
          self.scheduled_state.isScheduledPublish = false
          self.scheduled_state.scheduled_publish_date = null
        },
      },
      datum: null,
      mutators: [],
    }
    this.publishState = {
      handlers: {
        knock: function knock(state, defer) {
          state['datum'] = { isPublished: true, publishedDate: new Date() }
          defer.notify(state['datum'])
        },
        reset: function reset(state, defer) {
          delete self.storyObj.display_date
          delete self.storyObj.additional_properties.is_published
          delete self.storyObj.additional_properties.publish_date

          state['datum'] = { isPublished: false, publishedDate: null }
          defer.notify(state['datum'])
        },
      },
      datum: { isPublished: false, publishedDate: null },
      mutators: [
        function (state, defer) {
          locklessService
            .loadPublishState()
            .then(function loadPublishStateSuccess(publishState) {
              state['datum'] = publishState
              // defer.notify(state['datum'])
            })
        },
      ],
    }
    this.publishFieldBolts = {
      handlers: {
        updatePickers: function updatePickers(state, defer) {
          timePickerService
            .fetchPickers()
            .then(function fetchPickersSuccess(pickers) {
              // const newDateTimes = [{'label': 'Now', 'datum': new Date()}]

              let plannedPublishTimes = timePickerService
                .parseDatums('pp', pickers)
                .reduce(function parsedDatumReducer(acc, item) {
                  acc.push({
                    label: $filter('dateDisp')(item, DATEFORMAT),
                    datum: item,
                  })
                  return acc
                }, [])

              // Planned Publish
              let plannedTime = dataWranglingUtils.selectFirst(
                [
                  _.get(
                    self.storyObj,
                    'planning.scheduling.planned_publish_date'
                  ),
                ],
                [
                  [
                    dataWranglingUtils.isStringType,
                    function itemToDate(time) {
                      return moment(time).toDate()
                    },
                  ],
                  [
                    dataWranglingUtils.isMomentType,
                    function momentToDate(time) {
                      return time.toDate()
                    },
                  ],
                  [
                    dataWranglingUtils.isDateType,
                    function dateToDate(time) {
                      return time
                    },
                  ],
                ],
                undefined
              )
              if (angular.isDefined(plannedTime) && plannedTime !== null) {
                plannedPublishTimes.push({
                  label: `${$filter('dateDisp')(
                    plannedTime,
                    DATEFORMAT
                  )} (${intl.get('publishActions.publishModal.boltPlanned')})`,

                  datum: plannedTime,
                })
              }

              // Filter past times
              plannedPublishTimes = _.filter(
                plannedPublishTimes,
                function removePastDateTimes(time) {
                  return time['datum'] > new Date()
                }
              )

              // Angular isn't watching this [] for changes...reducing the cost of $scope.$watchers.
              state['datum'].splice(0, state['datum'].length)
              Array.prototype.push.apply(state['datum'], [
                { label: BOLT_NOW, datum: new Date() },
              ])
              plannedPublishTimes.sort(function (alpha, bravo) {
                return alpha['datum'] - bravo['datum']
              })
              Array.prototype.push.apply(state['datum'], plannedPublishTimes)
            })
        },
        update: function update(state, defer, jqEvent, bolt) {
          if (self.publishTimeLinked) {
            self.displayFieldBolts['handlers']['update'](jqEvent, bolt, true)
          }
          defer.notify(bolt)
        },
      },
      datum: [{ label: BOLT_NOW, datum: new Date() }],
      mutators: [
        'saveStory',
        function (state, defer, saveStory) {
          saveStory.then(null, null, function saveStoryHandler(storyObj) {
            state['handlers']['updatePickers'](state, defer)
          })
          state['handlers']['updatePickers'](state, defer)
        },
      ],
    }
    this.displayFieldLoading = { datum: false }
    this.displayField = {
      handlers: {
        update: function update(state, defer, jqEvent, time, isLinking) {
          if (time === null || angular.isUndefined(time)) {
            return false
          }
          state['datum']['calctrl'] = time
          if (
            !isLinking &&
            self.publishTimeLinked &&
            (self.publishField.datum && self.publishField.datum.getTime()) !==
              state['datum']['calctrl'].getTime()
          ) {
            self.toggleLinkPublishTime()
          }
          defer.notify(state['datum'])
        },
      },
      datum: {
        calctrl:
          existingDisplayDateFromStoryObject(self.storyObj) ||
          self.publishField.datum,
      },
      mutators: [
        'displayFieldBolts',
        (state, defer, displayFieldBolts) => {
          displayFieldBolts.then(null, null, (displayFieldBolts) => {
            state['datum']['calctrl'] = displayFieldBolts['datum']
          })
        },
      ],
    }
    this.displayFieldLabel = {
      handlers: {
        render: function render(state, defer) {
          if (state['datum']['displayFieldBolts']) {
            state['datum']['label'] =
              state['datum']['displayFieldBolts']['label']
            state['datum']['date'] =
              state['datum']['displayFieldBolts']['datum']
          } else if (
            state['datum']['existingDisplayDate'] &&
            state['datum']['existingDisplayDate']['datum']
          ) {
            state['datum']['label'] = renderExistingDisplayDateLabel(
              state['datum']['existingDisplayDate']['datum']
            )
            state['datum']['date'] =
              state['datum']['existingDisplayDate']['datum']
          } else if (state['datum']['displayField']) {
            state['datum']['label'] = $filter('dateDisp')(
              state['datum']['displayField']['calctrl'],
              DATEFORMAT
            )
            state['datum']['date'] = state['datum']['displayField']['calctrl']
          } else {
            state['datum']['label'] = BOLT_NOW
            state['datum']['date'] = null
          }
        },
      },
      datum: {
        date: null,
        label: (function resolveInitialDisplayFieldDatum(storyObj) {
          // lets get functional ^(^
          const date = existingDisplayDateFromStoryObject(storyObj)
          if (angular.isUndefined(date) || date === null) {
            return BOLT_NOW
          }
          return renderExistingDisplayDateLabel(date)
        })(self.storyObj),
        displayField: null,
        displayFieldBolts: null,
        existingDisplayDate: null,
      },
      mutators: [
        'displayField',
        'displayFieldBolts',
        'existingDisplayDate', // ANSProperty
        'unPublish',
        function (
          state,
          defer,
          displayField,
          displayFieldBolts,
          existingDisplayDate,
          unPublish
        ) {
          displayField.then(null, null, function handleDisplayField(
            displayField
          ) {
            state['datum']['displayField'] = displayField
            state['datum']['displayFieldBolts'] = null
            state['datum']['existingDisplayDate'] = null
            state['handlers']['render']()
          })
          displayFieldBolts.then(null, null, function displayFieldBoltsHandler(
            displayFieldBolts
          ) {
            state['datum']['displayFieldBolts'] = displayFieldBolts
            state['datum']['existingDisplayDate'] = null
            state['datum']['displayField'] = null
            state['handlers']['render']()
          })
          existingDisplayDate.then(
            null,
            null,
            function existingDisplayDateHandler(existingDisplayDate) {
              state['datum']['displayFieldBolts'] = null
              state['datum']['existingDisplayDate'] = existingDisplayDate
              state['datum']['displayField'] = null
              state['handlers']['render']()
            }
          )
          unPublish.then(null, null, function unPublishHandler(unPublish) {
            state['datum']['displayField'] = null
            state['datum']['displayFieldBolts'] = null
            state['datum']['existingDisplayDate'] = null
            state['handlers']['render']()
          })
        },
      ],
    }

    this.getInitPublishTimeLinked = () =>
      (this.publishField.datum && this.publishField.datum.getTime()) ===
      (this.displayField.datum.calctrl &&
        this.displayField.datum.calctrl.getTime())

    this.publishTimeLinked = this.getInitPublishTimeLinked()

    this.toggleLinkPublishTime = () => {
      this.publishTimeLinked = !this.publishTimeLinked
      return this.publishTimeLinked
    }

    this.matchDisplayDate = (jqEvent) => {
      if (this.commitPublication['datum']['publishFieldBolts']) {
        this.displayFieldBolts['handlers']['update'](
          jqEvent,
          this.commitPublication['datum']['publishFieldBolts'],
          true
        )
      } else {
        this.displayField['handlers']['update'](
          jqEvent,
          this.publishField['datum'],
          true
        )
      }
    }

    this.showDisplayTime = !this.publishTimeLinked

    this.toggleDisplayTime = () => {
      this.showDisplayTime = !this.showDisplayTime
    }

    // ANS Mutators
    this.existingDisplayDate = {
      handlers: {
        update: function (state, defer) {
          state['datum'] = existingDisplayDateFromStoryObject(self.storyObj)
          defer.notify(state)
        },
        reset: function (state, defer) {
          state['datum'] = existingDisplayDateFromStoryObject(self.storyObj)
          defer.notify(state)
        },
      },
      datum: existingDisplayDateFromStoryObject(self.storyObj),
      mutators: [
        'saveStory',
        function (state, defer, saveStory) {
          saveStory.then(null, null, function saveStoryHandler(storyObj) {
            state['datum'] = existingDisplayDateFromStoryObject(storyObj)
            if (state['datum']) {
              self.displayField.datum.calctrl = state['datum']
            } else {
              self.displayField.datum.calctrl = self.publishField.datum
            }
            self.publishTimeLinked = self.getInitPublishTimeLinked()
            self.showDisplayTime = !self.publishTimeLinked
            defer.notify(state)
          })
        },
      ],
    }
    this.displayFieldBolts = {
      handlers: {
        update: function update(state, defer, jqEvent, bolt, isLinking) {
          if (
            !isLinking &&
            self.publishTimeLinked &&
            self.publishFieldLabel['datum']['label'] !== bolt['label']
          ) {
            self.toggleLinkPublishTime()
          }
          defer.notify(bolt)
        },
      },
      datum: {
        bolts: buildInitialDisplayDateBolts(self.storyObj),
      },
      mutators: [
        'existingDisplayDate',
        'saveStory',
        function (state, defer, existingDisplayDate) {
          existingDisplayDate.then(
            null,
            null,
            function handleExistingDisplayDate(existingDisplayDate) {
              locklessService
                .loadPublishState()
                .then(function loadPublishStateSuccess(publishState) {
                  let labels = state['datum']['bolts'].reduce(function (
                    acc,
                    item
                  ) {
                    acc.push(
                      item['label']
                        .toLowerCase()
                        .indexOf(EXISTING_LABEL.toLowerCase())
                    )
                    return acc
                  },
                  [])
                  if (
                    (publishState.isPublished ||
                      self.scheduled_state.isScheduledPublish) &&
                    existingDisplayDate['datum'] !== null &&
                    _.filter(labels, function (item) {
                      return item > -1
                    }).length === 0
                  ) {
                    state['datum']['bolts'].push({
                      label: renderExistingDisplayDateLabel(
                        existingDisplayDate['datum']
                      ),
                      datum: existingDisplayDate['datum'],
                    })
                  } else if (
                    (publishState.isPublished ||
                      self.scheduled_state.isScheduledPublish) &&
                    _.filter(labels, function (item) {
                      return item < 0
                    }).length > 0
                  ) {
                    let datum = state['datum']['bolts'].splice(
                      0,
                      state['datum']['bolts'].length
                    )
                    Array.prototype.push.apply(
                      state['datum']['bolts'],
                      _.filter(datum, function (item) {
                        return (
                          item['label']
                            .toLowerCase()
                            .indexOf(EXISTING_LABEL.toLowerCase()) < 0
                        )
                      })
                    )
                    if (existingDisplayDate['datum'] !== null) {
                      state['datum']['bolts'].push({
                        label: renderExistingDisplayDateLabel(
                          existingDisplayDate['datum']
                        ),
                        datum: existingDisplayDate['datum'],
                      })
                    }
                  } else if (
                    existingDisplayDate['datum'] === null ||
                    (!publishState.isPublished &&
                      _.filter(labels, function (item) {
                        return item < 0
                      }).length > 0)
                  ) {
                    let datum = state['datum']['bolts'].splice(
                      0,
                      state['datum']['bolts'].length
                    )
                    Array.prototype.push.apply(
                      state['datum']['bolts'],
                      _.filter(datum, function (item) {
                        return (
                          item['label']
                            .toLowerCase()
                            .indexOf(EXISTING_LABEL.toLowerCase()) < 0
                        )
                      })
                    )
                  }
                })
            }
          )
        },
      ],
    }
    /*
     * Publication Flow
     *  Sometimes the story is saved without the intent to publish. Due to us having to talk to the ContentAPI before
     *   moving forward with the publication and a limitation in the AngularAPI. We'll have to set a boolean value
     *   to allow publication then, after a save-event is complete. We'll move forward with the publication.
     */
    this.saveStoryProgress = {
      // UIStateManager would normally handle this.
      handlers: {
        meepMeep: function beep(state, defer) {
          if (state['datum'] === false) {
            self.loading = true
            $('.feature-focused [contenteditablebind]').trigger('change input')
            // Add some listeners, giving the dom[:point_up:] some time to update and other things.
            const awe = $rootScope.$on('SAVE_SUCCESS', function (
              $event,
              storyObj
            ) {
              self.holders['publish_date'] = self.storyObj.publish_date
              self.holders['display_date'] = self.storyObj.display_date
              self.loading = false
              state['datum'] = false
              defer.notify('complete')
              awe()
            })
            state['datum'] = true
            defer.notify('begin')
            // hack to fix display_date null
            if (self.storyObj.display_date === null) {
              delete self.storyObj.display_date
            }
            storyService.save(true)
          }
        },
      },
      datum: false, // true is in progress
      mutators: [],
    }
    this.saveStory = {
      handlers: {},
      datum: self.storyObj,
      mutators: [
        'saveStoryProgress',
        function (state, defer, saveStoryProgress) {
          saveStoryProgress.then(null, null, function saveStoryProgress(
            progressEvent
          ) {
            if (progressEvent === 'begin') {
              const awe = $rootScope.$on('NEW_REVISION', function onNewRevision(
                $event,
                latestAnsSnapshot
              ) {
                state['datum']['revision'] = latestAnsSnapshot['revision']
                defer.notify(state['datum'])
                awe() // destroy listener
              })
            }
            // Shimmed as a dev-note.
            // if (progressEvent === 'complete') {
            // }
          })
        },
      ],
    }
    this.latestRevision = {
      handlers: {},
      datum: {
        revision: { revision_id: _.get(self.storyObj, 'revision.revision_id') },
      },
      mutators: [
        'saveStory',
        function latestRevisionUpdate(state, defer, saveStory) {
          saveStory.then(null, null, function saveStoryHandle(storyObj) {
            state['datum'] = {
              revision: {
                revision_id: _.get(storyObj, 'revision.revision_id'),
              },
            }
            defer.notify(state['datum'])
          })
        },
      ],
    }

    this.publishStory = (state, done) => {
      self.holdDates = true
      self.storyObj.additional_properties.publish_date = new Date().toJSON()
      // Shim ANSProperties that are filled in from the system.
      locklessService
        .loadPublishState()
        .then(function publishStateHandler(publishState) {
          state['datum']['request'] = true
          done()
        })
    }

    this.getScheduledOrPublishTime = () => {
      const scheduledPublishDate = _.get(
        self,
        'scheduled_state.scheduled_publish_date'
      )
      const publishedDate = _.get(self, 'publishState.datum.publishedDate')
      let minTime = 0
      if (!!publishedDate) {
        const publishTime = new Date(publishedDate).getTime()
        minTime = minTime < publishTime ? publishTime : minTime
      }

      if (!!scheduledPublishDate) {
        const scheduledTime = new Date(scheduledPublishDate).getTime()
        minTime = minTime < scheduledTime ? scheduledTime : minTime
      }
      return minTime
    }

    this.commitPublication = {
      handlers: {
        request: function requestPublication(state, defer) {
          // if NOW, reset publish time
          let isNow = _.get(self, 'publishFieldLabel.datum.label') === BOLT_NOW
          if (isNow) {
            state.datum.publishField = new Date()
          }

          // determine if a story is published by checking the selected publish date
          // if that publish date is "Now", then consider it published
          if (isNow) {
            self.storyObj.additional_properties.is_published = true
            self.scheduled_state.isScheduledPublish = false
          } else {
            self.storyObj.additional_properties.is_published = false
          }

          publishUnpublishedImages(self.storyObj)
            .then((response) => {
              if (response.unpublishedImagesFound) {
                if (!response.hasPPPermission) {
                  self.unpublishedImagesErrorMsg = response.message
                } else {
                  self.unpublishedImagesSuccessMsg = response.message
                }
              }
              self.publishStory(state, defer.notify)
            })
            .catch((err) => {
              toastr.error(
                getErrorMessage(err, 'Error while publishing Anglerfish images')
              )
            })
        },
        meepMeep: function meepMeep(state, defer) {
          const schedExpDate = self.expiration_state.scheduled_expiration_date
          if (schedExpDate && moment(schedExpDate).isBefore(moment())) {
            toastr.error(intl.get('publishActions.commitPublication.error'))
            return false
          }

          $('#publishModal').modal('show')
          self.saveStoryProgress.handlers.meepMeep()
        },
      },
      datum: {
        request: false,
        publishField: defaultPublishDate,
        displayField: null,
        publishFieldBolts: null,
        displayFieldBolts: null,
        existingDisplayDate: existingDisplayDateFromStoryObject(self.storyObj),
      },
      mutators: [
        'commitPublication',
        'publishField',
        'publishFieldBolts',
        'displayFieldBolts',
        function commitPublicationOnSaveStory(
          state,
          defer,
          commitPublication,
          publishField,
          publishFieldBolts
        ) {
          commitPublication.then(null, null, () => {
            if (state['datum']['request'] === true) {
              toastr.clear()
              state['datum']['request'] = false
              self.holdDates = false
              self.lockui.datum = true

              let publishDate = new Date()
              if (
                self.publishFieldLabel['datum']['label'].toLowerCase() !==
                  BOLT_NOW_ID &&
                self.publishFieldLabel['datum']['date']
              ) {
                publishDate = self.publishFieldLabel['datum']['date']
              }

              let displayDate = new Date()
              if (
                self.displayFieldLabel['datum']['label'].toLowerCase() !==
                  BOLT_NOW_ID &&
                self.displayFieldLabel['datum']['date']
              ) {
                displayDate = self.displayFieldLabel['datum']['date']
              }
              self.storyObj.display_date = displayDate.toISOString()
              self.storyObj.publish_date = publishDate.toISOString()
              const awe = $rootScope.$on('NEW_REVISION', function (
                $event,
                latestAnsSnapshot
              ) {
                awe()
                locklessService
                  .commitPublication({
                    display_date: displayDate,
                    _id: self.storyObj._id,
                    revision_id: latestAnsSnapshot['revision']['revision_id'],
                    editions: ['default'],
                    scheduleDateTime: publishDate,
                  })
                  .then(function commitPublicationSuccess([
                    publicationType,
                    storyObj,
                  ]) {
                    toastr.clear()
                    self.storyObj.display_date = displayDate.toISOString()

                    self.storyObj.canonical_url = storyObj.canonical_url

                    // On story publish/save, we'll simulate the UserInputs. This is becase the Save constantly refreshes
                    //  the state of the application. This allows us to maintain the userflow.
                    state['datum']['displayFieldBolts'] = {
                      label: renderExistingDisplayDateLabel(displayDate),
                      datum: existingDisplayDateFromStoryObject(self.storyObj), // do not share state outside this component
                    }
                    self.storyObj.publish_date = publishDate.toISOString()

                    // First time publishing, skipping scheduled publish stories
                    if (
                      !self.storyObj.first_publish_date &&
                      self.storyObj.additional_properties.is_published
                    ) {
                      self.storyObj.first_publish_date =
                        self.storyObj.publish_date
                    }

                    if (self.unpublishedImagesErrorMsg) {
                      toastr.error(self.unpublishedImagesErrorMsg)
                      self.unpublishedImagesErrorMsg = ''
                    } else if (self.unpublishedImagesSuccessMsg) {
                      toastr.success(self.unpublishedImagesSuccessMsg)
                      self.unpublishedImagesSuccessMsg = ''
                    }

                    if (publicationType === 'published') {
                      toastr.success(
                        intl.get(
                          'publishActions.commitPublicationSuccess.published'
                        )
                      )
                      self.publishState['handlers']['knock']()
                      $rootScope.$broadcast(
                        'ELLIPSIS_STORY_PUBLISHED',
                        storyObj._id
                      )
                      if (self.publishTimeLinked) {
                        self.toggleLinkPublishTime()
                      }
                      self.existingDisplayDate['handlers']['reset']()
                    } else {
                      toastr.success(
                        intl.get(
                          'publishActions.commitPublicationSuccess.scheduled'
                        )
                      )
                      // self.publishState['handlers']['reset']()
                      self.canUnschedule['handlers']['knock']()
                      self.scheduledState['handlers']['knock'](publishDate)
                      // self.publishState['handlers']['knock']()
                    }
                  })
                  .catch((response) => {
                    toastr.clear()
                    console.error(
                      'Story Publishing error: ',
                      response.data || response
                    )
                    if (response && response.status === 400) {
                      const { errorKey, errorData = {} } = response.data
                      toastr.error(
                        intl.get(
                          `publishActions.commitPublication.${errorKey}`
                        ),
                        '',
                        { timeOut: 20000 }
                      )
                      _.each(errorData, (error) => {
                        toastr.error(error, '', { timeOut: 20000 })
                      })
                    } else if (
                      response.status === 422 &&
                      _.get(response, 'data.errorData.field') ===
                        'revision.parent_id'
                    ) {
                      const { expected, value } = response.data.errorData

                      const errorMessage = intl.get(
                        'publishActions.commitPublication.invalidParentRevisionId',
                        {
                          providedParentRevisionId: value,
                          expectedParentRevisionId: expected,
                        }
                      )
                      toastr.error(errorMessage, undefined, {
                        allowHtml: true,
                        timeOut: 20000,
                      })
                    } else if (
                      response.status === 504 &&
                      _.get(response, 'data.error.message') ===
                        'Scheduler is busy or is not running'
                    ) {
                      toastr.error(
                        intl.get('publishActions.schedulePublish.error')
                      )
                    } else {
                      toastr.error(
                        _.has(response, 'data.errorKey')
                          ? intl.get(
                              `publishActions.commitPublication.${response.data.errorKey}`
                            )
                          : response.data
                      )
                    }
                  })
                  .then(() => {
                    self.lockui.datum = false
                  })
              })
              // hack to fix display_date null
              if (self.storyObj.display_date === null) {
                delete self.storyObj.display_date
              }
              storyService.save(true)
            }
          })
          publishField.then(null, null, function commitPubPublishFieldNotify(
            publishField
          ) {
            state['datum']['publishFieldBolts'] = null
            state['datum']['publishField'] = publishField
          })
          publishFieldBolts.then(
            null,
            null,
            function commitPubPublishFieldBoltsNotify(publishFieldBolts) {
              state['datum']['publishFieldBolts'] = publishFieldBolts // {label: str, datum: date}
              state['datum']['publishField'] = null
            }
          )
        },
      ],
    }

    const holdDatesProc = function holdDatesProc() {
      if (!self.holdDates) {
        if (
          self.holders['publish_date'] !== null &&
          angular.isDefined(self.holders['publish_date'])
        ) {
          self.storyObj.publish_date = self.holders['publish_date']
        }
        if (
          self.holders['display_date'] !== null &&
          angular.isDefined(self.holders['display_date'])
        ) {
          self.storyObj.display_date = self.displayFieldLabel['datum']['date']
          self.existingDisplayDate['handlers']['reset']()
          self.displayField['datum'][
            'calctrl'
          ] = existingDisplayDateFromStoryObject(self.storyObj)
          self.commitPublication['datum'][
            'displayField'
          ] = existingDisplayDateFromStoryObject(self.storyObj)
        }
        // reset Unpublish modal to Now
        self.unPublish.datum = _.get(
          self,
          'publishState.datum.isPublished',
          false
        )
          ? self.unPublish.boltTimes[0]
          : self.unPublish.blank
      }
    }
    // EL-1231
    this.calendarStateRequest = null
    $('#publishModal, #unpublishModal').on(
      'hidden.bs.modal',
      function hideCalCtrs(event) {
        this.calendarStateRequest = new StateRequest('close', true)
        holdDatesProc()
      }.bind(this)
    )

    toBeDestroyed.push(
      beatsService.addFunkyBeat(
        function validatePublicationDancer() {
          validationService
            .validatePublication(this.storyObj)
            .then(
              function validatePublicationSuccess(packetSuccess) {
                this.validPublication = true
                this.publishDisabledMsg = ''
              }.bind(this)
            )
            .catch(
              function handlePacketError(packetError) {
                if (exceptionTypes.ofValidationType(packetError)) {
                  let errorMessages = packetError.errors.map(
                    (o) =>
                      `Needs ${o.label} in order to publish. Set ${
                        o.label
                      } on the '${o.tab_name || o.tab}' tab.`
                  )
                  errorMessages = errorMessages.length
                    ? errorMessages.join(' ')
                    : ''
                  if (errorMessages !== this.publishDisabledMsg) {
                    this.publishDisabledMsg = errorMessages
                  }
                  errorMessages = null
                  this.validPublication = false
                } else {
                  throw packetError
                }
              }.bind(this)
            )
        }.bind(this)
      )
    )
    this.orgTimezone = $rootScope.globalSettings.timezone
    $rootScope.$on('SETTINGS_LOADED', (_, data) => {
      const { data: { timezone } = {} } = data || {}
      this.orgTimezone = timezone
    })

    this.scheduled_state.isScheduledPublish = false
    this.scheduled_state.scheduled_publish_date = null

    if (!_.get(this, 'storyObj._id')) {
      return
    }
  }

  let orgSettings = {}
  this.publish_state = {}
  this.scheduled_state = {}

  // TODO: userRolesAuth should be loaded from init data
  this.canSchedule = () => {
    return (
      typeof userRolesAuth !== 'undefined' &&
      userRolesAuth.org &&
      userRolesAuth.org.schedule_publish
    )
  }

  this.canScheduleUnpublish = () => {
    return (
      typeof userRolesAuth !== 'undefined' &&
      hasPermission(userRolesAuth.story.scheduleUnpublish) &&
      hasPermission(userRolesAuth.story.unpublish)
    )
  }

  this.showUnpublish = () => {
    return (
      (this.canUnpublish.datum ||
        (this.scheduled_state.isScheduledPublish &&
          this.canScheduleUnpublish())) &&
      !this.expiration_state.scheduled_expiration_date
    )
  }

  // TODO: Eric - This should be loaded off the init data
  settingsService.fetchCompanySettings().then((resp) => {
    orgSettings = resp.data
  })

  this.isStoryValidForPublish = () => {
    const story = this.story

    if (_.isEmpty(story.websites)) {
      this.publishDisabledMsg = intl.get(
        'publishActions.validation.websiteMissing'
      )
      return false
    }

    if (!story.canonical_website) {
      this.publishDisabledMsg = intl.get(
        'publishActions.validation.primaryWebsiteMissing'
      )
      return false
    }

    // restrict subsequent publish, when configured
    if (
      story.additional_properties.is_published &&
      typeof userRolesAuth !== 'undefined' &&
      userRolesAuth.story &&
      !hasPermission(userRolesAuth.story.publish, story.canonical_website) && // plain publish (any state) override
      !hasPermission(
        userRolesAuth.story.subsequentPublish,
        story.canonical_website
      )
    ) {
      this.publishDisabledMsg = intl.get(
        'publishActions.validation.unauthorizedSubsequentPublish',
        { canonicalWebsite: story.canonical_website }
      )
      return false
    }

    // restrict initial publish, when configured
    if (
      !story.additional_properties.is_published &&
      typeof userRolesAuth !== 'undefined' &&
      userRolesAuth.story &&
      !hasPermission(userRolesAuth.story.publish, story.canonical_website) && // plain publish (any state) override
      !hasPermission(
        userRolesAuth.story.initialPublish,
        story.canonical_website
      )
    ) {
      this.publishDisabledMsg = intl.get(
        'publishActions.validation.unauthorizedInitialPublish',
        { canonicalWebsite: story.canonical_website }
      )
      return false
    }

    // Old requirement, if story is already published, than allow it to be published.
    // Some imports did not have all the fields, but it is published, this gets around that
    if (story.additional_properties.is_published) {
      return true
    }

    // Sort of impossible to get into this state unless the button has a bug here it gets enabled somehow
    if (!story._id) {
      this.publishDisabledMsg = intl.get('publishActions.validation.unsaved')
      return
    }

    if (orgSettings && orgSettings.v2) {
      // Checkout beatsService
      //  I deleted the "return true" that was previously here that presumably was leveraging beatsService

      //  loop over the planning and meta tabs to see if an item is required to save or publish
      let errors = metaTemplatesService
        .requiredForPublish(orgSettings.v2, story)
        .filter((o) => o.missing === true)

      const featureMediaErrors = validationService.validateFeaturedMedia(
        story,
        orgSettings
      )
      if (featureMediaErrors && featureMediaErrors.length) {
        errors = [...errors, ...featureMediaErrors]
      }

      const errorMessages = errors.map((o) =>
        intl.get('publishActions.validation.requiredFieldMissing', {
          field: o.label,
          tabName: o.tab_name || o.tab,
        })
      )
      this.publishDisabledMsg = errorMessages.length
        ? errorMessages.join(' ')
        : ''
      return errorMessages.length === 0
    } else {
      // If we have no settings, than just check for section and headline.
      const isSectionsValid =
        story.taxonomy &&
        story.taxonomy.sections &&
        story.taxonomy.sections.length > 0
      const isHeadlineValid = story.headlines && story.headlines.basic

      this.publishDisabledMsg = ''

      if (!isSectionsValid) {
        this.publishDisabledMsg = intl.get(
          'publishActions.validation.sectionMissing'
        )
      }
      if (!isHeadlineValid) {
        this.publishDisabledMsg += intl.get(
          'publishActions.validation.headlineMissing'
        )
      }

      return isSectionsValid && isHeadlineValid
    }
  }

  this.unschedulePublish = () => {
    // if not published but is scheduled to publish, we remove all scheduled unpublish dates
    if (
      !this.canUnpublish.datum &&
      this.scheduled_state.isScheduledPublish &&
      this.canScheduleUnpublish()
    ) {
      this.unscheduleExpirationDate()
    }

    publishService.unschedule({ _id: this.story._id }).then(
      () => {
        this.scheduledState['handlers']['reset']()
        delete this.story.publish_date
        delete this.story.display_date
        delete this.story.additional_properties.is_published
        this.saveStoryProgress.handlers.meepMeep()
      },
      (...args) => {
        pharosService.sendErrorMessageToSentry(args)
        toastr.error(intl.get('publishActions.unschedulePublish.error'))
      }
    )
  }

  this.getOrgTimezone = () => {
    const date = moment.tz(this.orgTimezone)
    return `${date.tz()} ${date.format('Z')}`
  }

  this.unscheduleExpirationDate = () => {
    publishService
      .unscheduleUnpublish({
        story_id: this.storyObj._id,
      })
      .then((result) => {
        this.expiration_state.scheduled_expiration_date = null
        toastr.success(
          intl.get('publishActions.unscheduleExpirationDate.success')
        )
      })
  }

  this.storyHasChildClones = () => {
    return (this.storyObj.related_content.clonedChildren || []).length > 0
  }

  this.storyHasBeenClonedFromParent = () => {
    return (this.storyObj.related_content.clonedFromParent || []).length > 0
  }

  this.cancelChangesAndHideModal = () => {
    self.holdDates = true
    $('#publishModal').modal('hide')
  }
}
